import axios from "axios";

class TmzService {
    checkTmzStep() {
        return axios.get('tmz/check-tmz-step/');
    }

    importLiquidDemandTmzExcelOne(formData) {
        return axios.post('tmz/import_liquid_demand_tmz_excel_one_one/', formData,
            {
            responseType: 'blob',
            // onUploadProgress: e => this.progress = Math.round(e.loaded * 100 / e.total),
            // onUploadProgress: e => context.commit('setProgress', Math.round(e.loaded * 100 / e.total))
        });
    }

    importLiquidDemandTmzExcelOnePartTwo(formData) {
        return axios.post('tmz/import_liquid_demand_tmz_excel_one_two/', formData, {
            responseType: 'blob'
        });
    }

    editLiquidDemandTmzExcelOne(formData) {
        return axios.post('tmz/edit-liquid-demand-tmz-excel-one/', formData);
    }

    importLiquidUnclaimedTmzExcelTwo(formData) {
        return axios.post('tmz/import_liquid_unclaimed_tmz_excel_two_one/', formData, {
            responseType: 'blob'
        });
    }

    importLiquidUnclaimedTmzExcelTwoPartTwo(formData) {
        return axios.post('tmz/import_liquid_unclaimed_tmz_excel_two_two/', formData, {
            responseType: 'blob'
        });
    }

    editLiquidUnclaimedTmzExcelTwo(formData) {
        return axios.post('tmz/edit-liquid-unclaimed-tmz_excel-two/', formData);
    }

    importIlliquidTmzExcelThree(formData) {
        return axios.post('tmz/import_illiquid_tmz_excel_three_one/', formData, {
            responseType: 'blob'
        });
    }

    importIlliquidTmzExcelThreePartTwo(formData) {
        return axios.post('tmz/import_illiquid_tmz_excel_three_two/', formData, {
            responseType: 'blob'
        });
    }

    editIlliquidTmzExcelThree(formData) {
        return axios.post('tmz/edit-illiquid-tmz-excel-three/', formData);
    }

    getTmzReport(id) {
        return axios.get(`tmz/tmz-view/${id}/`);
    }

    rmTmzReport(id) {
        return axios.delete(`tmz/tmz-view/${id}/`);
    }

    decideProblem() {
        return axios.get(`tmz/decide_problem/`);
    }

    getLiquidDemandReport(id) {
        return axios.get(`tmz/liquid-demand/${id}/`);
    }

    getLiquidDemandReportRequest(formData) {
        return axios.get(`tmz/liquid-demand-req/`, {
            params: {
                liquidDemandId: formData.liquidDemandId,
                category: formData.category,
                codeTmc: formData.codeTmc,
                nameTmc: formData.nameTmc,
            }
        });
    }


    getLiquidDemandRequestDataDate(id) {
        return axios.get(`tmz/liquid-demand-req-data/${id}/date/`);
    }


    getLiquidDemandRequestDataPrice(id) {
        return axios.get(`tmz/liquid-demand-req-data/${id}/price/`);
    }

    getLiquidUnclaimedReportRequest(formData) {
        return axios.get(`tmz/liquid-unclaimed-req/`, {
            params: {
                liquidUnclaimedId: formData.liquidUnclaimedId,
                category: formData.category,
                codeTmc: formData.codeTmc,
                nameTmc: formData.nameTmc,
            }
        });
    }

    getLiquidUnclaimedRequestDataDate(id) {
        return axios.get(`tmz/liquid-unclaimed-req-data/${id}/date/`);
    }

    getIlliquidReportRequest(formData) {
        return axios.get(`tmz/illiquid-req/`, {
            params: {
                illiquidId: formData.illiquidId,
                codeTmc: formData.codeTmc,
                nameTmc: formData.nameTmc,
            }
        });
    }

    getIlliquidRequestDataDate(id) {
        return axios.get(`tmz/illiquid-req-data/${id}/date/`);
    }

    getLiquidUnclaimedReport(id) {
        return axios.get(`tmz/liquid-unclaimed/${id}/`);
    }

    getIlliquidReport(id) {
        return axios.get(`tmz/illiquid/${id}/`);
    }

    sendSignXmlTmz(formData) {
        return axios.post('tmz/sign_xml/', {
            'signedXml': formData.signedXml,
            'reportId': formData.reportId
        });
    }

    getAllTmzReports() {
        return axios.get(`tmz/all-tmz/`);
    }

    getAllNotMyTmzReports() {
        return axios.get(`tmz/all-not-my-tmz/`);
    }

    getTmzHistory(id) {
        return axios.get(`tmz/tmz-history/`, {params: {id: id}});
    }

    rejectTmzReportDzo(formData) {
        return axios.post('tmz/reject-tmz-report/', {
            formData: formData
        })
    }

    rejectTmzReportAllow(formData) {
        return axios.get('tmz/reject-tmz-report/', {
            params: {
                reportId: formData.reportId
            }
        })
    }

    sendTmzEditFile(formData) {
        return axios.post('tmz/send-tmz-edit-file/', formData);
    }

    downLoadTmzExcel(formData) {
        return axios.get('tmz/download-excel/',{
            params: {
                reportId: formData.reportId
            },
            responseType: 'blob'
        });
    }

    downErrorExcel(tmzId) {
        return axios.get(`tmz/tmz-error/${tmzId}/download-excel/`,{
            responseType: 'blob'
        });
    }

    getTmzFormSix(reportId) {
        return axios.get('tmz/tmz-six-form/',{
            params: {
                reportId: reportId
            },
        });
    }
}

export default new TmzService()
